import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import CustomButton from "../../../components/ui/button";
import FieldLabel from "../../../components/label";
import SectionTitle from "../../../components/sectionTitle";
import { withStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { validateInputLength } from "../../../helpers/utils";
import { BUTTON_PROCEED } from "../../../constants";
// import { Utils } from "../../../constants/utils";
import { useStyles } from "../indexFormStyles";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    paddingLeft: 0,
  },
  "& .MuiInputAdornment-root": {
    backgroundColor: "#ECF0F4", // theme.palette.divider,
    padding: "28px 14px",
    borderTopLeftRadius: theme.shape.borderRadius + "px",
    borderBottomLeftRadius: theme.shape.borderRadius + "px",
    fontSize: "1rem !important",
  },
  "& .MuiFormHelperText-root": {
    color: "#ff585d",
  },
}));

const HeightConverter = ({
  classes: { formGroup },
  errorMessage,
  form,
  handleChange,
  onClose,
  handleProceed,
  modal,
  onSubmit,
  modalKey = "open",
}) => {
  return (
    <Dialog
      onClose={(event, reason) => onClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal.open}
    >
      <DialogTitle id="simple-dialog-title">
        <Box display="flex" justifyContent="center">
          <SectionTitle
            title={"Height Converter"}
            onClickHandler={handleProceed}
          />
        </Box>
      </DialogTitle>

      <Box m={1}>
        <form noValidate autoComplete="off" onSubmit={onSubmit}>
          <Box className={formGroup}>
            <FieldLabel label={`Height in feets and inches*`} />
            <Grid container spacing={1} mb={1}>
              <Grid item xs={6}>
                <CustomTextField
                  id="standard-basic"
                  variant="outlined"
                  value={form.heightFeet}
                  name="heightFeet"
                  onInput={validateInputLength}
                  onChange={handleChange}
                  autoComplete="off"
                  helperText={errorMessage.heightFeet}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="subtitle1">Feets</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <CustomTextField
                  id="standard-basic"
                  variant="outlined"
                  value={form.heightInch}
                  name="heightInch"
                  onInput={validateInputLength}
                  onChange={handleChange}
                  autoComplete="off"
                  helperText={errorMessage.heightInch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="subtitle1">Inches</Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          <Box className={formGroup}>
            <FieldLabel label={`Height in centimeters*`} />
            <TextField
              type="text"
              id="standard-basic"
              variant="outlined"
              value={form.heightCm}
              name="heightCm"
              onInput={validateInputLength}
              onChange={handleChange}
              autoComplete="off"
              helperText={errorMessage.heightCm}
              fullWidth
              disabled={true}
            />
          </Box>

          <Box layout="column" mt={2} mb={0}>
            <CustomButton size="large" color="primary" title={BUTTON_PROCEED} />
          </Box>
        </form>
      </Box>
    </Dialog>
  );
};

export default withStyles(useStyles, { withTheme: true })(HeightConverter);
